import { render } from "./humanityCourseCreate.vue?vue&type=template&id=0b50a954&scoped=true"
import script from "./humanityCourseCreate.vue?vue&type=script&lang=js"
export * from "./humanityCourseCreate.vue?vue&type=script&lang=js"

import "./humanityCourseCreate.vue?vue&type=style&index=0&id=0b50a954&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b50a954"]])

export default __exports__